module.exports = __webpack_public_path__ + "static/media/menu13.ccd4c1c1.jpg";